<template>
  <div>
    <nav class="nav flex-column">
      <a class="nav-link active agrey" href="#/tools">{{ $t('tools') }}</a>
      <a class="nav-link agrey" href="#/usb">{{ $t('setupProg') }}</a>
      <a v-if="lShowKiBolt" class="nav-link agrey" href="#/kiprog">{{ $t('setupKiProg') }}</a>
      <!--
      <a v-if="lShowKiBolt" class="nav-link agrey" href="#/kibolt">{{ $t('readAnKiBolt') }}</a>
      -->
    </nav>
  </div>
</template>

<script>
export default {
  name: 'MenuSetup',
  computed: {
      lShowKiBolt () {
        return this.$store.state.showKibolt;
      }
  },
  created: function () {
  },
  beforeDestroy(){
  }
}
</script>
<style scoped>
a {
  color:grey;
    /*font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;*/
}
.agrey {
  color:grey;
}
</style>
